<template lang="pug">
  v-dialog(
    v-model="show"
    max-width="600px"
  )
    template(v-slot:activator="{ on }")
      v-btn(
        v-on="on"
        :fab="buttonOptions.fab"
        :xSmall="buttonOptions.fab"
        :rounded="!buttonOptions.fab"
        :filled="!buttonOptions.fab"
        :color="buttonOptions.color"
        :text="buttonOptions.text"
        :class="buttonOptions.class"
      ) {{ buttonOptions.label }}
        v-icon(
          v-if="buttonOptions.icon"
          :left="!buttonOptions.fab"
          :class="{ 'mx-2': !buttonOptions.fab }"
        ) {{ buttonOptions.icon }}
    v-card
      v-card-title.headline
        slot(name="header")
        v-spacer
        v-btn(@click="close" icon)
          v-icon mdi-close
      v-card-text(class="dialog-text")
        slot(name="body")
      v-divider
      v-card-actions
        slot(name="actions" :close="close")
          v-spacer
          v-btn(@click="close" color="warning" text) Закрыть

</template>

<script>
export default {
  name: 'SdoDialog',
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    buttonOptions: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      show: false,
    };
  },
  watch: {
    show(val) {
      if (val) this.$emit('open');
    },
  },
  methods: {
    close() {
      // this.$emit('input', false);
      this.show = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.dialog-text {
  font-size: 1rem;
}

</style>
